import { MapfreSlideToggleComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-slide-toggle/mapfre-slide-toggle.component';
import { MapfreLabelComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-label/mapfre-label.component';
import { ProfileImpNoticeComponent } from '../profile-imp-notice/profile-imp-notice.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit , NO_ERRORS_SCHEMA } from '@angular/core';
import { FormGroup, FormControl, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import {
  ModalOptions,
  AlertService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import _ from 'underscore';
import { uniqBy } from 'lodash';
import { UserDataService } from '../../../../../_services/data-services/user-data.service';
import { EditContactService } from '../../../../../_services/edit-contact.service';
import { Router , RouterModule } from '@angular/router';
import { PhoneFormatter } from '../../../../../_helpers/_formatters/phone-formatter';
import { phoneValidator } from '../../../../../_helpers/_validators/phone-validator';
import { ChangeProfileEmailService } from '../../../../../_services/profile-settings/change-profile-email.service';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { UserDetailsService } from '../../../../../_services/profile-settings/user-details.service';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import { take } from 'rxjs/operators';
import { OktaAuthService } from '@services/_iam/okta-auth.service';
import { InputMaskDirective } from '@helpers/_directives/input-mask.directive';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreModalComponent, MapfreButtonComponent, ProfileImpNoticeComponent, MapfreLabelComponent, MapfreSlideToggleComponent, InputMaskDirective],
  selector: 'app-edit-contact',
  templateUrl: './edit-contact.component.html',
  styleUrls: ['./edit-contact.component.scss'],
})
export class EditContactComponent implements OnInit {
  editContactForm: FormGroup;
  emailUpdateModal: ModalOptions;
  inputs: any[];
  mobilePrimaryStatus = false;
  homePrimaryStatus = false;
  workPrimaryStatus = false;
  hideModal = false;
  loader = false;
  showEmailUpdateModal = false;
  policyNumbers: string[];
  agentDetails: any[] = [];
  uniqueAgents: any[] = [];
  userDetails: any = {};
  user: any;
  emailPattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  phonePattern = /^((?!0)[0-9]{3}-[0-9]{3}-[0-9]{4})$/;
  phoneTypes = ['mobilePhone', 'homePhone', 'workPhone'];
  contact: any = {};
  phoneCount: number;
  unsetTheSwitch = false;
  policiesArr = [];
  isEmailChanged = false;
  customClass = '';
  showEmailAlreadyExistMsg = false;
  isAcmic: boolean;
  isAS400Policy: boolean;
  existActiveGWPolicy: boolean;
  showProfileImpNotice: boolean;
  mobilePhoneUpdated = false;
  homePhoneUpdated = false;
  workPhoneUpdated = false;
  notificationMsg;

  constructor(
    private policyDataService: PolicyDataService,
    private userDataService: UserDataService,
    private editContactService: EditContactService,
    private router: Router,
    private alertService: AlertService,
    public phoneFormatter: PhoneFormatter,
    private changeProfileEmailService: ChangeProfileEmailService,
    private errorRedirectionService: ErrorRedirectionService,
    private userDetailsService: UserDetailsService,
    private storageService: StorageServiceObservablesService,
    private acmicService: AcmicService,
    private cdr: ChangeDetectorRef,
    private oktaAuthService: OktaAuthService
  ) {
    this.isAS400Policy = false;
    this.existActiveGWPolicy = false;
    this.showProfileImpNotice = true;
  }

  isEmptyField(key) {
    const formValid = this.editContactForm.controls[key];
    return formValid.dirty && formValid.value === '';
  }
  isValid(key) {
    const formValid = this.editContactForm.controls[key];
    return formValid.touched && formValid.errors;
  }
  isPrimaryStatusSet() {
    return (
      !this.mobilePrimaryStatus &&
      !this.workPrimaryStatus &&
      !this.homePrimaryStatus
    );
  }
  
  onClose(event) {
    if(event) {
      setTimeout(() => {
        this.showProfileImpNotice = false;
      });
    }
  }
  checkForPhoneCount() {
    this.phoneCount = 0;
    this.phoneTypes.forEach((phoneType) => {
      if (this.editContactForm.controls[phoneType].value !== '') {
        this.phoneCount++;
      }
    });
  }
  checkForSwitchAndRemove(key) {
    this.checkForPhoneCount();
    const formControl = this.editContactForm.controls[key];
    if (formControl.value && !formControl.errors) {
      if (
        !this.unsetTheSwitch &&
        (this.isPrimaryStatusSet() || !this.phoneCount)
      ) {
        this.setAsPrimary('', key);
      }
      return true;
    }
    return false;
  }
  resetPrimaryStatus() {
    this.mobilePrimaryStatus = false;
    this.homePrimaryStatus = false;
    this.workPrimaryStatus = false;
  }
  clearPrimary() {
    this.resetPrimaryStatus();
    this.unsetTheSwitch = true;
  }
  setAsPrimary(event, type, isPrimary?) {
    this.checkForPhoneCount();
    if (isPrimary) {
      if (this.phoneCount) {
        // make to unset the switch, to stop the default switch
        this.clearPrimary();
      } else {
        this.resetPrimaryStatus();
        this.unsetTheSwitch = false;
      }
      return;
    }
    if (type === 'mobilePhone') {
      this.mobilePrimaryStatus = true;
      this.homePrimaryStatus = false;
      this.workPrimaryStatus = false;
    } else if (type === 'homePhone') {
      this.mobilePrimaryStatus = false;
      this.homePrimaryStatus = true;
      this.workPrimaryStatus = false;
    } else {
      this.mobilePrimaryStatus = false;
      this.homePrimaryStatus = false;
      this.workPrimaryStatus = true;
    }
  }
  checkPhonesExists(otherPhone) {
    if (this.editContactForm.controls[otherPhone].value !== '') {
      this.setAsPrimary('', otherPhone);
      return true;
    }
  }
  checkForOther(key) {
    if (key === this.phoneTypes[0]) {
      if (!this.checkPhonesExists(this.phoneTypes[1])) {
        this.checkPhonesExists(this.phoneTypes[2]);
      }
    } else if (key === this.phoneTypes[1]) {
      if (!this.checkPhonesExists(this.phoneTypes[0])) {
        this.checkPhonesExists(this.phoneTypes[2]);
      }
    } else {
      if (!this.checkPhonesExists(this.phoneTypes[0])) {
        this.checkPhonesExists(this.phoneTypes[1]);
      }
    }
  }
  onInput(key, isPrimary) {
    this.checkForPhoneCount();
    if (this.editContactForm.controls[key].value === '') {
      if (isPrimary || this.phoneCount === 1) {
        this.checkForOther(key);
      }
    }
    if (!this.phoneCount) {
      this.resetPrimaryStatus();
      this.unsetTheSwitch = false;
    }
  }
  clearPhoneInput(key, isPrimary) {
    this.editContactForm.controls[key].setValue('');
    this.checkForPhoneCount();
    if (isPrimary || this.phoneCount === 1) {
      this.checkForOther(key);
    }
    if (!this.phoneCount) {
      this.resetPrimaryStatus();
      this.unsetTheSwitch = false;
    }
  }
  resetHideModal(): void {
    this.hideModal = !this.hideModal;
    this.showEmailUpdateModal = false;
  }
  getChangedPhoneList() {
    const phoneArr = [];
    this.userDetails.phoneList.forEach((phone) => {
      const phoneNum = phone.number ? this.phoneFormatter.format(phone.number) : "";
      if (phone.type === 'cell' || phone.type === 'Mobile') {
        phoneArr.push({
          phoneNumber: this.editContactForm.value.mobilePhone,
          oldPhoneNumber: phoneNum,
          type: 'cell',
          primary: this.mobilePrimaryStatus,
          phoneNumUpdated: phoneNum !== this.editContactForm.value.mobilePhone,
        });
      } else if (phone.type === 'home') {
        phoneArr.push({
          phoneNumber: this.editContactForm.value.homePhone,
          oldPhoneNumber: phoneNum,
          type: 'home',
          primary: this.homePrimaryStatus,
          phoneNumUpdated: phoneNum !== this.editContactForm.value.homePhone,
        });
      } else if (phone.type === 'work') {
        phoneArr.push({
          phoneNumber: this.editContactForm.value.workPhone,
          oldPhoneNumber: phoneNum,
          type: 'work',
          primary: this.workPrimaryStatus,
          phoneNumUpdated: phoneNum !== this.editContactForm.value.workPhone,
        });
      }
    });
    return phoneArr;
  }
  buildContactObject() {
    this.contact = {
      contact: {
        nameInfo: {
          firstName: this.userDetails.firstName,
          middleName: '',
          lastName: this.userDetails.lastName,
        },
        emailList: [
          {
            emailAddress: this.editContactForm.value.contactEmail,
            oldEmailAddress: this.userDetails.email.address,
            type: 'Primary',
          },
        ],
        phoneList: this.existActiveGWPolicy ? this.getChangedPhoneList() : [],
        policiesAgents: this.uniqueAgents,
        policyNumbers: this.policyNumbers
      },
    };
    return this.contact;
  }
  reSyncUserData(email, resp): void {
    void email;
    void resp;
    //this.storageService.setUserStorage(email, resp);
    this.oktaAuthService.refreshTokenAfterEmailUpdate().then(() => {
      this.userDetailsService.getUserDetailsByEmail().pipe(take(1)
      ).subscribe({
        next: () => {
          this.doPostContactUpdateActions(this.contact);
        },
        error: (error) => {
          this.errorRedirectionService.errorRedirectHandler(error);
        }
      });
    }
    )
  }

  updateContactDetails() {
    this.loader = true;
    this.editContactService
      .editContactDetails(this.userDetails.email.address, this.contact)
      .subscribe(
        (data) => {
          this.setUpdatedPhoneNumToInsured();
          if (this.isEmailChanged) {
            setTimeout(() => {
              this.reSyncUserData(this.editContactForm.value.contactEmail, data);
            }, 5000);
          } else {
            this.user.userDetails.phoneList = this.getPhoneListFromForm();
            this.userDataService.updateUserDetails(this.user);
            this.doPostContactUpdateActions(this.contact);
          }
        },
        (error) => {
          this.loader = false;
          this.errorRedirectionService.errorRedirectHandler(error);
        }
      );
  }
  doPostContactUpdateActions(contactInfo?) {
    this.updateContactAction(contactInfo.contact);
  }
  updateContactAction(contactInfo) {
    contactInfo.phoneList.forEach((phone) => {
      if(phone.type === 'cell' || phone.type === 'Mobile') {
        this.mobilePhoneUpdated = phone.phoneNumUpdated;
      } else if (phone.type === 'home') {
        this.homePhoneUpdated = phone.phoneNumUpdated;
      } else if (phone.type === 'work') {
        this.workPhoneUpdated = phone.phoneNumUpdated;
      }
    });

    let alertMessage;
    if(this.isEmailChanged && this.mobilePhoneUpdated && this.homePhoneUpdated && this.workPhoneUpdated) {
        alertMessage = `Your email, mobile, home, and work phone numbers have been updated. <br><br>
                        Changes made to your email will update your login credentials and apply to all active policies. <br><br>
                        Phone number changes apply only to active policies.`;
    } else if(this.mobilePhoneUpdated && this.homePhoneUpdated && this.workPhoneUpdated) {
      alertMessage = `Your mobile, home, and work phone numbers have been updated.
                      Changes made to your account will apply to all active policies.`
    } else if(this.isEmailChanged && (this.mobilePhoneUpdated || this.homePhoneUpdated || this.workPhoneUpdated)) {
        if(this.mobilePhoneUpdated && this.homePhoneUpdated) {
          alertMessage = `Your email, mobile, and home phone numbers have been updated. <br><br>
                        Changes made to your email will update your login credentials and apply to all active policies. <br><br>
                        Phone number changes apply only to active policies.`;

        } else if(this.mobilePhoneUpdated && this.workPhoneUpdated) {
          alertMessage = `Your email, mobile, and work phone numbers have been updated. <br><br>
                        Changes made to your email will update your login credentials and apply to all active policies. <br><br>
                        Phone number changes apply only to active policies.`;

        } else if(this.homePhoneUpdated && this.workPhoneUpdated) {
          alertMessage = `Your email, home, and work phone numbers have been updated. <br><br>
                        Changes made to your email will update your login credentials and apply to all active policies. <br><br>
                        Phone number changes apply only to active policies.`;

        } else {
          let typeNum;
          if(this.mobilePhoneUpdated) {
            typeNum = "mobile";
          } else if(this.homePhoneUpdated) {
            typeNum = "home";
          } else {
            typeNum = "work";
          }
          alertMessage = `Your email and ${typeNum} phone number have been updated. <br><br>
                          Changes made to your email will update your login credentials and apply to all active policies. <br><br>
                          Phone number changes apply only to active policies.`;
        }
    } else if(this.mobilePhoneUpdated || this.homePhoneUpdated || this.workPhoneUpdated) {
      alertMessage = `Your phone number has been updated. This change will apply to all active policies.`;
        if(this.mobilePhoneUpdated && this.homePhoneUpdated) {
          alertMessage = `Your mobile, and home phone numbers have been updated.
                          Changes made to your account will apply to all active policies.`;
        } else if(this.mobilePhoneUpdated && this.workPhoneUpdated) {
          alertMessage = `Your mobile, and work phone numbers have been updated.
                          Changes made to your account will apply to all active policies.`;
                          
        } else if(this.homePhoneUpdated && this.workPhoneUpdated) {
          alertMessage = `Your home, and work phone numbers have been updated.
                          Changes made to your account will apply to all active policies.`;
        }
    } else {
      alertMessage = `Your email has been updated. This change will update your login credentials and apply to all active policies.`;
    }
    this.alertService.success(alertMessage, true, 'Account updated!');
    if(this.isEmailChanged && this.existActiveGWPolicy){
      this.router.navigate(['profile', 'wallet-details']);
    } else{
      this.router.navigate(['profile', 'manage-contact-details']);
    } 
  }


  getPrimaryType() {
    if (this.mobilePrimaryStatus) {
      return 'MOBILE';
    } else if (this.homePrimaryStatus) {
      return 'HOME';
    }
    return 'WORK';
  }
  setUpdatedPhoneNumToInsured() {
    const fistPolicy = this.policiesArr[0];
    let insuredToUpdate = fistPolicy.insured.find(
      (insuredElm) => insuredElm.displayPhone
    );
    const insuredIndex = fistPolicy.insured.findIndex(
      (insuredElm) => insuredElm.displayPhone
    );
    insuredToUpdate = {
      ...insuredToUpdate,
      mobilePhone: this.editContactForm.value.mobilePhone,
      homePhone: this.editContactForm.value.homePhone,
      workPhone: this.editContactForm.value.workPhone,
      primaryPhoneType: this.getPrimaryType(),
    };
    fistPolicy.insured[insuredIndex] = insuredToUpdate;
    this.policiesArr[0] = fistPolicy;
    this.policyDataService.updatePolicyDetails(this.policiesArr);
  }
  confirmNewEmail() {
    this.checkAndChangeEmail(
      this.userDetails.email.address,
      this.editContactForm.value.contactEmail
    );
  }
  editContact() {
    this.buildContactObject();
    if (
      this.userDetails.email.address !== this.editContactForm.value.contactEmail
    ) {
      this.isEmailChanged = true;
      this.showEmailUpdateModal = true;
    } else {
      this.updateContactDetails();
    }
  }
  getPhoneListFromForm() {
    return [
      {
        number: this.editContactForm.value.mobilePhone,
        type: 'cell',
        primary: this.mobilePrimaryStatus,
      },
      {
        number: this.editContactForm.value.homePhone,
        type: 'home',
        primary: this.homePrimaryStatus,
      },
      {
        number: this.editContactForm.value.workPhone,
        type: 'work',
        primary: this.workPrimaryStatus,
      },
    ];
  }
  checkAndChangeEmail(currentEmail, newEmail) {
    this.loader = true;
    this.changeProfileEmailService
      .checkEmailExists(currentEmail, newEmail)
      .subscribe(
        () => {
          this.loader = false;
          this.closeMe();
          this.updateContactDetails();
        },
        () => {
          this.loader = false;
          this.showEmailAlreadyExistMsg = true;
          window.scroll(0, 0);
        }
      );
  }
  closeMe() {
    this.showEmailAlreadyExistMsg = false;
  }

  getUniqueAgents() {
    const agents = [];
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.isAS400Policy =
          policyResponse[0] &&
          policyResponse[0].policynumber.policyNumber.length === 6;
        policyResponse.forEach((policy) => {
          agents.push({
            agentName: policy.agent.agentName,
            agentCode: policy.agent.agentCode.code,
            agentEmail: policy.agent.agentEmail,
            policyNumbers: [],
          });
        });

        this.uniqueAgents = uniqBy(agents, (e) => {
          return e.agentCode;
        });
        this.getPolicies();
      }
    });
  }

  getPolicies() {
    this.policyNumbers = [];
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policiesArr = policyResponse;
        _.filter(policyResponse, (policy) => {
          this.policyNumbers.push(policy.policynumber.policyNumber);
          if (
            policy.policyStatus === 'ACTIVE' &&
            policy.policynumber.policyNumber.length === 10
          ) {
            this.uniqueAgents.forEach((agent, i) => {
              if (policy.agent.agentCode.code == agent.agentCode) {
                this.uniqueAgents[i]['policyNumbers'].push(
                  policy.policynumber.policyNumber
                );
              }
            });
          }
        });
      }
    });
  }

  setModal() {
    this.emailUpdateModal = new ModalOptions({
      additionalClasses:
        'modal-lg modal-dialog center-on-page confirm-modal email-update confirm-email-update-modal edit-contact-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'emailUpdateModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: '',
      // modalTranslateCopy: 'Confirm email update',
      size: 'modal-lg',
      modalName: 'email_Update_Modal',
    });
  }
  setFormGroup() {
    this.editContactForm = new FormGroup({
      contactEmail: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailPattern),
        Validators.minLength(5),
      ]),
      workPhone: new FormControl('', [
        Validators.maxLength(12),
        phoneValidator(this.phoneFormatter),
      ]),
      homePhone: new FormControl('', [
        Validators.maxLength(12),
        phoneValidator(this.phoneFormatter),
      ]),
      mobilePhone: new FormControl('', [
        Validators.maxLength(12),
        Validators.compose([phoneValidator(this.phoneFormatter)]),
      ]),
    });
  }
  setPhoneData(key, value) {
    if (value) {
      this.editContactForm.get(key).setValue(this.phoneFormatter.format(value));
    }
  }
  setEmailDatatoForm(email) {
    this.editContactForm.get('contactEmail').setValue(email);
  }
  checkPrimaryPhone(phoneList) {
    let type;
    phoneList.forEach((phone) => {
      type =
        phone.type === 'cell'
          ? 'mobilePhone'
          : phone.type.toLowerCase() + 'Phone';
      this.setPhoneData(type, phone.number);
      if (phone.primary) {
        this.setAsPrimary('', type);
      }
    });
  }
  getUserData() {
    this.userDataService.$userData.subscribe((user) => {
      if (user && user.userDetails) {
        this.user = user;
        this.userDetails = user.userDetails;
        this.checkPrimaryPhone(this.userDetails.phoneList);
        this.setEmailDatatoForm(this.userDetails.email.address);
      }
    });
  }

  setUniqueAgents(policyList: any[]) {
    const agents = [];
    policyList.forEach((policy) => {
      agents.push({
        agentName: policy.agent.agentName,
        agentCode: policy.agent.agentCode?.code ? policy.agent.agentCode?.code : "",
        agentEmail: policy.agent.agentEmail ? policy.agent.agentEmail : "",
        policyNumbers: [],
      });
    });

    this.uniqueAgents = uniqBy(agents, (e) => {
      return e.agentCode;
    });
    this.getPolicies();
  }

  ngOnInit(): void {
    this.customClass = this.acmicService.isACMIC() ? '' : 'cp-w-226';
    this.isAcmic = this.acmicService.isACMIC();
    this.setFormGroup();
    this.getUserData();
    this.setModal();
    this.notificationMsg = {
      title: 'Important notice',
      textOne: `Changing your email will update your login credentials and apply to all active policies. This will require re-entering any saved digital wallet cards.`,
      textTwo: `Phone number changes apply to all your active policies.`
    }
    // this.getUniqueAgents();

    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.isAS400Policy =
          policyResponse[0] &&
          policyResponse[0].policynumber.policyNumber.length === 6;
        this.existActiveGWPolicy = !!policyResponse.find(policy => policy.policynumber?.policyNumber.length === 10
          && policy.company?.companyName !== "ACIC" && policy.company?.companyName !== "TW"
          && policy.policyStatus === 'ACTIVE')

        this.setUniqueAgents(policyResponse)
      }
    });
  }
}
